import N8nLink from './Link.vue';

export default N8nLink;
